// extracted by mini-css-extract-plugin
module.exports = {"login__box":"style_login__box__20o4F","login__forgetpassword":"style_login__forgetpassword__3xw_Z"};